import { REACT_HOT_TOAST_ERROR, REACT_HOT_TOAST_SUCCESS } from "../../../../../_CORE/HELPERS/reactHotToast.helper";
import { onWishlistMoney, onWishlistPriorityLabel, onWishlistTotalsLabel } from "./wishlist.util";

const copyText = async (value) => {
    const text = String(value ?? "");
    if (!text) return false;
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        try {
            const area = window.document.createElement("textarea");
            area.value = text;
            area.setAttribute("readonly", "");
            area.style.position = "fixed";
            area.style.opacity = "0";
            window.document.body.appendChild(area);
            area.select();
            const ok = window.document.execCommand("copy");
            window.document.body.removeChild(area);
            return ok;
        } catch {
            return false;
        }
    }
};

const exportRow = (key, label, value) => ({ key, label, value, isSecret: false });

export const copyWishlistExternalLink = async (url) => {
    const ok = await copyText(url);
    if (ok) REACT_HOT_TOAST_SUCCESS("Link del artículo copiado");
    else REACT_HOT_TOAST_ERROR("No se pudo copiar el link");
    return ok;
};

export const wishlistItemExportRows = (item, categoryName = "") => {
    const quantity = Math.max(1, Number(item.quantity || 1));
    const hasPrice = item.price !== null && item.price !== undefined && item.price !== "";
    const total = hasPrice ? Number(item.price) * quantity : null;
    return [
        exportRow("category", "Categoría", categoryName),
        exportRow("name", "Artículo", item.name),
        exportRow("description", "Descripción", item.description),
        exportRow("store", "Tienda / vendedor", item.store),
        exportRow("price", "Precio", hasPrice ? onWishlistMoney(item.price, item.currency) : ""),
        exportRow("quantity", "Cantidad", quantity),
        exportRow("total", "Total", total === null ? "" : onWishlistMoney(total, item.currency)),
        exportRow("priority", "Prioridad", onWishlistPriorityLabel(item.priority)),
        exportRow("status", "Estado", item.isPurchased ? "Comprado" : "Pendiente"),
        exportRow("url", "Link del artículo", item.url),
        exportRow("imageUrl", "Imagen", item.imageUrl),
        exportRow("notes", "Notas", item.notes),
    ];
};

export const wishlistCategoryExportRows = (category, items = []) => {
    const itemLines = items.map((item, index) => {
        const quantity = Math.max(1, Number(item.quantity || 1));
        const amount = item.price === null || item.price === undefined
            ? "Sin precio"
            : onWishlistMoney(Number(item.price) * quantity, item.currency);
        const store = item.store ? ` · ${item.store}` : "";
        const status = item.isPurchased ? "Comprado" : "Pendiente";
        return `${index + 1}. ${item.name} · ${amount}${store} · ${status}${item.url ? ` · ${item.url}` : ""}`;
    }).join("\n");

    return [
        exportRow("category", "Categoría", category.name),
        exportRow("description", "Descripción", category.description),
        exportRow("items", "Artículos", items.length),
        exportRow("purchased", "Comprados", items.filter((item) => item.isPurchased).length),
        exportRow("pending", "Pendientes", items.filter((item) => !item.isPurchased).length),
        exportRow("total", "Total", onWishlistTotalsLabel(items)),
        exportRow("detail", "Detalle", itemLines),
    ];
};
